module.exports = __webpack_public_path__ + "static/media/study 201031.4fbe7670.png";